import { Spacer } from "../../../../components/common/Spacer";
import Input from "views/components/common/Input/Input";
import React, { useEffect } from "react";

export const Step1 = ({ onChange, value, setIsDisabled, errors, info }) => {
	useEffect(() => {
		if (value) {
			if (
				info.hasOwnProperty("isEmpty") ||
				info.hasOwnProperty("email")
			) {
				setIsDisabled(true);
			} else {
				setIsDisabled(false);
			}
		}
	}, [info]);

	return (
		<>
			<Input
				name="name"
				label="Nombre"
				required={true}
				type="text"
				onChange={onChange}
			/>
			<Spacer rows={1} />
			<Input
				name="email"
				label="Email"
				required={true}
				type="email"
				onChange={onChange}
			/>
		</>
	);
};
